// this middleware is used for fetching content.json file from public/data/ 
// in future only this file will requird to change for API integration

export const getContent = async () => {
  const response = await fetch("/data/content.json");

  if (!response.ok) {
    throw new Error("Failed to fetch Content");
  }

  return response.json();
};
